import { Modal } from "antd";
import "../../styles/AIInsightModal.css";
import {
  CloseOutlined,
  ExclamationOutlined,
  CheckOutlined,
  InfoOutlined,
} from "@ant-design/icons";
import { useFetchFunction } from "../../utils/hooks/UseFetchUrl";
import { useEffect } from "react";

const defaultFindings = [
  {
    id: 1,
    type: "success",
    title: "What went well",
    points: [
      "Strong product knowledge and clear explanation of features and benefits.",
      "Pricing and financing options were explained clearly.",
      "Follow-up was completed promptly after the visit.",
    ],
  },
  {
    id: 2,
    type: "critical",
    title: "What didn't go well",
    points: ["Test-drive vehicle was not available at the showroom."],
  },
  {
    id: 3,
    type: "warning",
    title: "What can be improved",
    points: [
      "Improve test-drive vehicle availability to enhance customer convenience.",
    ],
  },
];

const iconMap = {
  critical: <ExclamationOutlined />,
  warning: <ExclamationOutlined />,
  success: <CheckOutlined />,
  info: <InfoOutlined />,
};

const AIInsightModal = ({ open, onClose, overallScore = 0, auditStoreId }) => {
  const { loading, data, getData } = useFetchFunction();

  useEffect(() => {
    if (!open || !auditStoreId) return;

    getData(`client/sentiment_data/${auditStoreId}`);
  }, [open, auditStoreId]);

  const quickInsight =
    data?.quick_insight ||
    " Strong product knowledge, clear pricing explanation and a prompt follow-up made this a good visit. Test-drive vehicle availability was the one gap to address.";

  return (
    <Modal
      className="ai-insight-modal"
      open={open}
      onCancel={onClose}
      footer={null}
      closable={false}
      width={600}
      loading={loading}
    >
      <div className="ai-insight-header">
        <div className="ai-insight-title-wrap">
          <div className="rbAiBtn">
            <span className="geminiSparkle">✦</span>
          </div>
          <h3 className="ai-insight-title">AI Analysis</h3>
        </div>
        <button className="ai-insight-close-btn" onClick={onClose}>
          <CloseOutlined />
        </button>
      </div>
      <div className="ai-insight-divider" />

      <div className="ai-insight-sub-header">
        <div className="ai-insight-meta-row">
          <span className="code">{data?.[0]?.audit?.store?.code ?? "N/A"}</span>
          <span className="sep">|</span>
          <span className="dealer">
            {data?.[0]?.audit?.store?.name ?? "N/A"}
          </span>
        </div>
        <div className="ai-insight-score-row">
          <span className="label">Overall Score</span>
          <span className="ai-insight-score-badge">{overallScore}%</span>
        </div>
      </div>

      <div className="ai-insight-section-heading">Quick Insight</div>
      <p className="ai-insight-paragraph">{quickInsight}</p>

      <div className="ai-insight-divider" />

      <div className="ai-insight-section-heading">Key Findings</div>
      {/* <div className="ai-insight-findings-list">
        {defaultFindings.map((f) => (
          <div className="ai-insight-finding-item" key={f.id}>
            <div className={`ai-insight-icon-wrap ${f.type}`}>
              {iconMap[f.type]}
            </div>
            <div className="ai-insight-finding-text">
              <div className="ai-insight-finding-title">{f.title}</div>
              <div className="ai-insight-finding-desc">{f.description}</div>
            </div>
          </div>
        ))}
      </div> */}
      <div className="ai-insight-findings-list">
        {defaultFindings.map((f) => (
          <div className={`ai-insight-finding-item ${f.type}`} key={f.id}>
            <div className={`ai-insight-icon-wrap ${f.type}`}>
              {iconMap[f.type]}
            </div>
            <div className="ai-insight-finding-text">
              <div className="ai-insight-finding-title">{f.title}</div>
              <ul className="ai-insight-bullets">
                {f.points.map((point, i) => (
                  <li key={i}>{point}</li>
                ))}
              </ul>
            </div>
          </div>
        ))}
      </div>
    </Modal>
  );
};

export default AIInsightModal;
